var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { fabric } from 'fabric';
import jhttp from 'jhttp';
import { base64ToBlob } from '@mademine/utils';
import { Upload, thirdServiceUsed, faceDetect } from '@sunzi/utils';
import { SaveLocalKey } from '../config';
export var host7n = {
    token: 'https://sunzi.stylelab.com',
    'upload-na0': 'https://upload-na0.qiniup.com',
    'prefix-na0': 'https://sunzi7n.imaiyuan.com/',
    'upload-z0': 'https://up-z0.qiniup.com/',
    'prefix-z0': 'https://versa.myuxc.com/'
};
export var thumbnail7n = function (url, size) {
    return "".concat(url, "?imageView2/0/w/").concat(size, "/h/").concat(size, "/interlace/1|imageslim");
};
export var thumbnailOss = function (url, size) {
    return "".concat(replaceUrlAsOss(url), "?x-oss-process=image/resize,w_").concat(size, ",h_").concat(size);
};
export var replaceUrlAsOss = function (url) {
    var urlArr = url.split('/');
    var name = urlArr[urlArr.length - 1];
    return "https://sunzi-us-east.maiyuan.online/mini-me/".concat(name);
};
export var getKeyPoint = function (avatar, feature) {
    var landmark = avatar.faceRecognizeData.landmark;
    if (feature === 'head') {
        var leftEyebrow = landmark.leftEyebrow, rightEyebrow = landmark.rightEyebrow;
        var keyPoint = {
            x: (leftEyebrow.x + rightEyebrow.x) / 2,
            y: leftEyebrow.y < rightEyebrow.y ? leftEyebrow.y : rightEyebrow.y
        };
        return keyPoint;
    }
    else if (feature === 'mouse') {
        var mouthLowerLip = landmark.mouthLowerLip, mouthUpperLip = landmark.mouthUpperLip;
        var keyPoint = {
            x: (mouthLowerLip.x + mouthUpperLip.x) / 2,
            y: (mouthLowerLip.y + mouthUpperLip.y) / 2
        };
        return keyPoint;
    }
    else {
        var leftEyePupil = landmark.leftEyePupil, rightEyePupil = landmark.rightEyePupil;
        var keyPoint = {
            x: (leftEyePupil.x + rightEyePupil.x) / 2,
            y: (leftEyePupil.y + rightEyePupil.y) / 2
        };
        return keyPoint;
    }
};
export var loadImageFromURL = function (URL, option) {
    if (option === void 0) { option = {}; }
    return new Promise(function (resolve, reject) {
        fabric.Image.fromURL(URL, function (image) {
            if (URL && (image.width === 0 || image.height === 0))
                reject('图片文件加载失败，请检查您的网络环境是否通畅！');
            resolve(image);
        }, __assign({ crossOrigin: 'anonymous' }, option));
    });
};
export var loadSVGFromURL = function (url) {
    return new Promise(function (resolve) {
        fabric.loadSVGFromURL(url, function (object) {
            resolve(fabric.util.groupSVGElements(object));
        });
    });
};
export var compressImage = function (source, maxValue) { return __awaiter(void 0, void 0, void 0, function () {
    var canvas, ctx, image, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                canvas = document.createElement('canvas');
                ctx = canvas.getContext('2d', { willReadFrequently: true });
                return [4, loadHTMLImage(source)];
            case 1:
                image = _a.sent();
                canvas.width = maxValue;
                canvas.height = (maxValue * image.height) / image.width;
                if (image.width < image.height) {
                    canvas.height = maxValue;
                    canvas.width = (canvas.height * image.width) / image.height;
                }
                ctx === null || ctx === void 0 ? void 0 : ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, canvas.width, canvas.height);
                result = canvas.toDataURL('image/jpeg');
                canvas.width = canvas.height = 0;
                return [2, result];
        }
    });
}); };
export var loadHTMLImage = function (base64) {
    return new Promise(function (resolve, reject) {
        var image = new Image();
        image.crossOrigin = 'anonymous';
        image.onload = function () { return resolve(image); };
        image.onerror = reject;
        image.src = base64;
    });
};
export var loadBase64FromURL = function (URL, maxWidth, format, quality) {
    if (maxWidth === void 0) { maxWidth = 400; }
    if (format === void 0) { format = 'jpeg'; }
    if (quality === void 0) { quality = 0.5; }
    return new Promise(function (resolve, reject) {
        var image = new Image();
        image.crossOrigin = 'anonymous';
        image.onload = function () {
            var canvas = document.createElement('canvas');
            canvas.width = Math.min(maxWidth, image.width);
            canvas.height = (canvas.width * image.height) / image.width;
            var ctx = canvas.getContext('2d', { willReadFrequently: true });
            ctx === null || ctx === void 0 ? void 0 : ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, canvas.width, canvas.height);
            var base64 = canvas.toDataURL("image/".concat(format), quality);
            canvas.width = canvas.height = 0;
            resolve(base64);
        };
        image.onerror = reject;
        image.src = URL;
    });
};
export var getBlobUrl = function (url) {
    return new Promise(function (resolve) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.responseType = 'blob';
        xhr.onload = function () {
            if (this.status === 200)
                resolve(URL.createObjectURL(this.response));
        };
        xhr.send();
    });
};
export var calcFacePosition = function (_a) {
    var domWith = _a.domWith, option = _a.option, peopleNumber = _a.peopleNumber, avatars = _a.avatars;
    var bottomImageHeight = (option.origin.height / option.origin.width) * domWith;
    var avatarLeftPrecents = [];
    var avatarTopPrecents = [];
    var avatarWidthPecents = [];
    var avatarHeightPecents = [];
    var avatarScales = [];
    var avatarAngles = [];
    var defaultSetting = function (length, index) {
        if (length === void 0) { length = peopleNumber; }
        if (index === void 0) { index = 0; }
        var avatar = option.origin.avatar;
        var avatarItem = avatar[index];
        var avatarLeft = ((avatarItem.left + avatarItem.width / 2) / option.origin.width) * domWith;
        var avatarLeftPrecent = avatarLeft / domWith;
        var avatarTop = ((avatarItem.top + avatarItem.height) / option.origin.height) *
            bottomImageHeight;
        var avatarTopPrecent = avatarTop / bottomImageHeight;
        var avatarWidth = (avatarItem.width / option.origin.width) * domWith;
        var avatarWidthPecent = avatarWidth / domWith;
        var avatarHeight = (avatarItem.height / option.origin.height) * bottomImageHeight;
        var avatarHeightPecent = avatarHeight / bottomImageHeight;
        avatarLeftPrecents.push.apply(avatarLeftPrecents, new Array(length).fill("".concat(avatarLeftPrecent * 100, "%")));
        console.log(avatarTopPrecent);
        avatarTopPrecents.push.apply(avatarTopPrecents, new Array(length).fill("".concat(avatarTopPrecent * 100, "%")));
        avatarWidthPecents.push.apply(avatarWidthPecents, new Array(length).fill("".concat(avatarWidthPecent * 100, "%")));
        avatarHeightPecents.push.apply(avatarHeightPecents, new Array(length).fill("".concat(avatarHeightPecent * 100, "%")));
        avatarScales.push.apply(avatarScales, new Array(length).fill(1));
        avatarAngles.push.apply(avatarAngles, new Array(length).fill(undefined));
    };
    if (avatars.length > 0) {
        avatars.forEach(function (avatar, index) {
            if (avatar.faceRecognizeData &&
                avatar.width &&
                avatar.height &&
                option.origin.face) {
                var faceRect = avatar.faceRecognizeData.faceRect;
                var face = option.origin.face;
                var faceItem = face[index];
                var faceWidth = (faceItem.width / option.origin.width) * domWith;
                var faceHeight = (faceItem.height / option.origin.height) * bottomImageHeight;
                var avatarScale = Math.min(faceWidth / faceRect.width, faceHeight / faceRect.height);
                var heightDistance = (avatar.height - faceRect.top - faceRect.height) * avatarScale;
                var avatarWidth = avatar.width * avatarScale;
                var avatarWidthPecent = avatarWidth / domWith;
                var avatarHeight = avatar.height * avatarScale;
                var avatarHeightPecent = avatarHeight / (bottomImageHeight || 1);
                var avatarTop = ((faceItem.top + faceItem.height) / option.origin.height) *
                    bottomImageHeight +
                    heightDistance;
                var avatarLeft = (faceItem.left / option.origin.width) * domWith -
                    faceRect.left * avatarScale +
                    avatarWidth / 2;
                var avatarLeftPrecent = avatarLeft / domWith;
                var avatarTopPrecent = avatarTop / (bottomImageHeight || 1);
                avatarLeftPrecents.push("".concat(avatarLeftPrecent * 100, "%"));
                avatarTopPrecents.push("".concat(avatarTopPrecent * 100, "%"));
                avatarWidthPecents.push("".concat(avatarWidthPecent * 100, "%"));
                avatarHeightPecents.push("".concat(avatarHeightPecent * 100, "%"));
                avatarScales.push(avatarScale);
                avatarAngles.push(faceItem.angle);
            }
            else
                defaultSetting(1, index);
        });
    }
    else
        defaultSetting();
    return {
        bottomImageHeight: bottomImageHeight,
        avatarLeftPrecents: avatarLeftPrecents,
        avatarTopPrecents: avatarTopPrecents,
        avatarWidthPecents: avatarWidthPecents,
        avatarHeightPecents: avatarHeightPecents,
        avatarScales: avatarScales,
        avatarAngles: avatarAngles
    };
};
export var saveLocalImage = function (userImage) {
    var stringData = window.localStorage.getItem(SaveLocalKey);
    if (stringData) {
        var data = JSON.parse(stringData);
        for (var i = 0; i < data.length; i++) {
            var current = data[i].source;
            if (current === userImage.source) {
                return;
            }
        }
        data.unshift(userImage);
        var size = JSON.stringify(data).length / 1024 / 1024;
        if (size > 4.5) {
            data.pop();
        }
        window.localStorage.setItem(SaveLocalKey, JSON.stringify(data));
    }
    else {
        var data = [userImage];
        window.localStorage.setItem(SaveLocalKey, JSON.stringify(data));
    }
};
export var findSelectedColor = function (colors, selectedSkinColor, peopleNumber) {
    if (typeof selectedSkinColor === 'string') {
        var result = colors.find(function (item) { return item.name === selectedSkinColor; });
        if (peopleNumber === 1) {
            return [result];
        }
        else
            return new Array(peopleNumber).fill(__assign({}, result));
    }
    else if (selectedSkinColor.length === peopleNumber) {
        return selectedSkinColor.map(function (selectItem, index) {
            return colors.find(function (item) { return item.belongPeople === index && item.name === selectItem; });
        });
    }
    console.error('默认选择皮肤色与皮肤色数据对不上，请检查您的数据');
    return [];
};
export var getFaceData = function (image) { return __awaiter(void 0, void 0, void 0, function () {
    var imageData, _a, landmark, face_rectangle, chin, leftEyebrow, rightEyebrow, leftEyePupil, rightEyePupil, nose, mouthLowerLip, mouthUpperLip, error_1;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, 3, 4]);
                return [4, faceDetect(base64ToBlob(image))];
            case 1:
                imageData = _b.sent();
                _a = imageData[0], landmark = _a.landmark, face_rectangle = _a.face_rectangle;
                chin = landmark.contour_chin;
                leftEyebrow = landmark.left_eyebrow_upper_middle;
                rightEyebrow = landmark.right_eyebrow_upper_middle;
                leftEyePupil = landmark.left_eye_pupil;
                rightEyePupil = landmark.right_eye_pupil;
                nose = landmark.nose_tip;
                mouthLowerLip = landmark.mouth_lower_lip_top;
                mouthUpperLip = landmark.mouth_upper_lip_bottom;
                return [2, {
                        landmark: {
                            chin: chin,
                            leftEyebrow: leftEyebrow,
                            rightEyebrow: rightEyebrow,
                            leftEyePupil: leftEyePupil,
                            rightEyePupil: rightEyePupil,
                            nose: nose,
                            mouthLowerLip: mouthLowerLip,
                            mouthUpperLip: mouthUpperLip
                        },
                        faceRect: face_rectangle
                    }];
            case 2:
                error_1 = _b.sent();
                throw new Error('network error');
            case 3:
                thirdServiceUsed({
                    source: 4,
                    type: 5,
                    internalSource: 3
                });
                return [7];
            case 4: return [2];
        }
    });
}); };
export var getToken7n = function () {
    var args_1 = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args_1[_i] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([], args_1, true), void 0, function (bucket) {
        var response;
        if (bucket === void 0) { bucket = 'sunzi_ai'; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, jhttp.get("".concat(host7n.token, "/qiniu/token/bucket"), { bucket: bucket })];
                case 1:
                    response = _a.sent();
                    if (response.error === 0) {
                        return [2, response.token];
                    }
                    return [2, ''];
            }
        });
    });
};
export var dateTime = "".concat(new Date().getFullYear()).concat(new Date().getMonth() + 1).concat(new Date().getDate());
export var uuid = function () {
    var s = [];
    var hexDigits = '0123456789abcdef';
    for (var i = 0; i < 36; i++)
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    s[14] = '4';
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
    s[8] = s[13] = s[18] = s[23] = '-';
    return s.join('');
};
export var uploadKey = function (type) { return "".concat(type, "/").concat(dateTime, "/").concat(uuid()); };
export var upload7n = function (params, onprogress) {
    return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.upload.onprogress = function (e) {
            if (e.total > 0)
                onprogress && onprogress((e.loaded / e.total) * 100);
        };
        var formData = new FormData();
        formData.append('file', params.file);
        formData.append('token', params.token);
        formData.append('key', params.key);
        xhr.onload = function () {
            if (xhr.status < 200 || xhr.status >= 300)
                reject();
            else {
                var text = xhr.responseText || xhr.response;
                try {
                    return resolve(JSON.parse(text));
                }
                catch (e) {
                    reject();
                }
            }
        };
        xhr.onerror = reject;
        xhr.open('post', params.bucket || host7n['upload-na0'], true);
        xhr.send(formData);
    });
};
export var upload7nB64 = function (params, onprogress) {
    return upload7n({
        file: base64ToBlob(params.base64),
        token: params.token,
        key: params.key,
        bucket: params.bucket
    }, onprogress);
};
export var upload2Oss = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var base64, blob, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                base64 = params.base64;
                blob = base64ToBlob(base64);
                return [4, new Upload().prefix('mini-me').upload(blob)];
            case 1:
                data = _a.sent();
                return [2, data];
        }
    });
}); };
export var getZIndex = function (type, data, index) {
    var arr = new Array(data.face.length + 1).fill(undefined);
    data.face.forEach(function (item) {
        if (item.zIndex !== undefined)
            arr[item.zIndex] = true;
    });
    var bodyIndex = arr.findIndex(function (item) { return item === undefined; }) || 0;
    switch (type) {
        case 'body':
            return bodyIndex;
        case 'face': {
            var jumpIndex_1 = 1;
            data.face.some(function (item, faceIndex) {
                if (faceIndex === index)
                    return true;
                if (item.zIndex === undefined && faceIndex !== index)
                    jumpIndex_1 += 1;
            });
            var zIndex = arr.findIndex(function (item) {
                if (item === undefined && jumpIndex_1 === 0)
                    return true;
                if (item === undefined)
                    jumpIndex_1 -= 1;
            });
            return zIndex > -1 ? zIndex : 0;
        }
        default:
            return 0;
    }
};
